var symphony = symphony || {};

symphony.nav = {
    closeAll: function () {
        document.querySelectorAll('.viewingChild').forEach(function (elm) {
            elm.classList.remove('viewingChild');
        });
    },

    // for sym 2016 theme
    toggleChild: function (e, elm) {
        e = e || window.event;
        e.preventDefault();
        e.stopPropagation();

        if (elm.parentElement.classList.contains('viewingChild')) {
            elm.parentElement.classList.remove('viewingChild');
        } else {
            elm.parentElement.classList.add('viewingChild');
        }
    },

    // for kroc theme
    goBack: function (elm) {
        elm.parentElement.parentElement.parentElement.classList.remove('viewingChild');
    },
    viewChild: function (e, elm) {
        e = e || window.event;
        e.preventDefault();
        e.stopPropagation();
        elm.parentElement.parentElement.classList.add('viewingChild');
    }
};
